import React, { useState, useEffect } from "react"
import { IoIosArrowRoundForward } from "react-icons/io"

// Helpers
import { truncate } from '../../helpers'

// Libs
import slugify from 'slugify'

// Gatsby
import { useStaticQuery, graphql, navigate } from "gatsby"
import Img from "gatsby-image"

// Styles
import styles from './styles.module.css'

const Subhero = () => {
  const [treatments, setTreatments] = useState()
  const data = useStaticQuery(graphql`
  query GetTreatments {
      allStrapiService {
        nodes {
          image {
            childImageSharp {
              fixed(height: 400) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          description
          intro
          title
          strapiId
        }
      }
    }
  `)

  useEffect(() => {
    if (data && data.allStrapiService?.nodes) {
      setTreatments(data.allStrapiService.nodes.map(n => ({ ...n, image: n.image.childImageSharp.fixed })))
    }
  }, [data])

  return (
    <section className="grid grid-cols-12 bg-gray-100 -mt-32" id="services">
      <div className="col-start-2 col-span-10">
        <div className="grid grid-cols-12 h-full">
          {treatments && treatments.map((t, i) => {
            const className = `treatment-box lg:col-span-3 col-span-12 text-center relative cursor-default ${i % 2 === 0 ? "bg-white" : "bg-main_color"}`
            const animation = i % 2 === 0 ? 'fade-down' : 'fade-up'
            return (
              <div data-aos={animation} data-aos-duration="800" data-aos-offset="300" style={{ minHeight: 750 }} key={t.title} className={className}>
                <Img className={styles.subHeroImg} objectFit="fit" fixed={t.image} />
                <h3 className="text-xl font-medium tracking-wider mt-4">{t.title}</h3>
                <h4 className="mt-4 font-thin text-sm px-8 text-justify">{truncate(t.intro, 200, true)}</h4>
                <div style={{ bottom: 30, left: "50%", transform: "translate(-50%, 50%)" }} className="flex justify-center items-center mb-2 cursor-pointer absolute" onClick={() => navigate(`services/${slugify(t.title)}`)}>
                  <p className="font-light mt-8">Ver Servicio</p>
                  <IoIosArrowRoundForward className="text-xl mt-4" />
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className="col-span-12 text-center my-5">
        <h5 className="text-5xl font-light">Médicos Especialistas de Reconocida Trayectoria</h5>
      </div>
    </section >
  )
}

export default Subhero